// ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = location.pathname.split('/')[1];
  
  const isTokenValid = token && token.length > 15;
  if (!isTokenValid) {
    return <Navigate to="/404" replace />;
  }
  
  return children;
};

export default ProtectedRoute;